module.exports = __webpack_public_path__ + "img/IMG-4838.b4842082.jpg";